/* ===== SAFETY PATCH: Privacy, Mengenrabatt-Text, Gallery, Accordion ===== */
(() => {
  // ---------- PRIVACY / CHECKOUT-SPERRE ----------
  const privacyRoots = Array.from(document.querySelectorAll('.privacy-cart'));

  const setCheckoutDisabled = (originEl, disabled) => {
    const ctx = originEl?.closest?.('.cart-drawer, .cart') || document;
    const btn = ctx.querySelector('button[name="checkout"]');
    if (btn) btn.disabled = !!disabled;
  };

  const onPrivacyClick = (ev) => {
    const t = ev.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.matches('.privacy-cart #privacy, .privacy-cart #privacy_drawer')) return;
    setCheckoutDisabled(t, !t.checked);
  };

  if (privacyRoots.length) {
    privacyRoots.forEach((root) => {
      const privacyDrawer = root.querySelector('#privacy_drawer');
      if (privacyDrawer && privacyDrawer.checked) privacyDrawer.checked = false;
      const anyChecked = !!root.querySelector('#privacy:checked, #privacy_drawer:checked');
      setCheckoutDisabled(root, !anyChecked);
    });
    document.addEventListener('click', onPrivacyClick, { passive: true });
  }

  // ---------- MENGENRABATT-TEXT ----------
  setTimeout(() => {
    const specTextElement = document.querySelector('#quantity-discount-app .spec_text');
    if (specTextElement && document.documentElement.lang === 'en') {
      let html = specTextElement.innerHTML;
      html = html.replace('Ab', 'For orders of');
      html = html.replace('Stück erhalten Sie einen Rabatt von', 'or more, you will receive a discount of');
      html = html.replace('off', 'per item');
      specTextElement.innerHTML = html;
    }
  }, 2000);

  // ---------- GALLERY / MEDIA-CAROUSEL ----------
  const initGallery = () => {
    const gallery = document.querySelector('media-carousel');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.product-gallery__media');
    if (!slides.length) return;

    const getCurrentIndex = () =>
      Array.from(slides).findIndex(s => s.classList.contains('is-selected'));

    const hasSelectMethod = typeof gallery.select === 'function';

    const goToIndex = (idx) => {
      if (idx < 0 || idx >= slides.length) return;
      if (hasSelectMethod) {
        try { gallery.select(idx); } catch (e) {}
      } else {
        const cur = getCurrentIndex();
        if (cur >= 0) slides[cur].classList.remove('is-selected');
        slides[idx].classList.add('is-selected');
      }
    };
    // (Optional: hier left/right Arrow-Logik, wenn du willst, via goToIndex)
  }; // <-- WICHTIG: Funktion sauber schließen!

// Pfeile steuern die Galerie-Logik (Synchron mit Thumbnails)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-gallery__arrow');
    if (!btn) return;

    const gallery = document.querySelector('media-carousel');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.product-gallery__media');
    if (!slides.length) return;

    // Aktuellen Index finden
    const currentIndex = Array.from(slides).findIndex(s => 
      s.classList.contains('is-selected') || s.getAttribute('aria-hidden') === 'false'
    );
    
const isRight = btn.classList.contains('product-gallery__arrow--right');
    let nextIndex;

    if (isRight) {
      nextIndex = currentIndex + 1;
      // Wenn wir über das letzte Bild hinausgehen -> zurück zu Bild 0
      if (nextIndex >= slides.length) {
        nextIndex = 0;
      }
    } else {
      nextIndex = currentIndex - 1;
      // Wenn wir vor das erste Bild gehen -> zum letzten Bild springen
      if (nextIndex < 0) {
        nextIndex = slides.length - 1;
      }
    }

    // Die echte Galerie-Methode aufrufen
    if (typeof gallery.select === 'function') {
      try {
        gallery.select(nextIndex);
      } catch (err) {
        console.error("Fehler beim Wechseln des Bildes:", err);
      }
    } else {
      // Fallback: Manuelles Umschalten der Klassen, falls .select() versagt
      slides.forEach(s => s.classList.remove('is-selected'));
      slides[nextIndex].classList.add('is-selected');
      slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });

// ---------- ACCORDION ----------
const initAccordion = () => {
  const items = document.querySelectorAll('.accordion-item');
  if (!items.length) return;

  items.forEach((item, index) => {
    const title = item.querySelector('.accordion-title');
    const content = item.querySelector('.accordion-content');
    if (!title || !content) return;

    // Erstes Panel beim initialen Laden offen lassen
    if (index === 0 && !item.classList.contains('active')) {
      item.classList.add('active');
      content.style.display = 'block';
    } else if (!item.classList.contains('active')) {
      content.style.display = 'none';
    }

    // doppelte Listener vermeiden
    if (title.dataset.bound === 'true') return;
    title.dataset.bound = 'true';

    title.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Nur das geklickte Panel toggeln — NICHT die anderen schließen
      if (isActive) {
        item.classList.remove('active');
        content.style.display = 'none';
      } else {
        item.classList.add('active');
        content.style.display = 'block';
      }
    }, { passive: true });
  });
};

  // ---------- INITIALISIERUNG ----------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGallery();
      initAccordion();
    });
  } else {
    initGallery();
    initAccordion();
  }

  // bei dynamischem Nachladen erneut
  document.addEventListener('shopify:section:load', () => {
    initGallery();
    initAccordion();
  });
})(); // <-- WICHTIG: IIFE sauber schließen!

// Entfernt leere Judge.me Preview-Badges + deren umgebenden Block
(function () {
  function pruneEmptyJudgeBlocks() {
    document.querySelectorAll('.product-info__block-item[data-block-type="@app"]').forEach(function (block) {
      const widget = block.querySelector('.jdgm-widget.jdgm-preview-badge');
      if (!widget) return;

      const zeroReviews =
        widget.getAttribute('data-number-of-reviews') === '0' ||
        widget.getAttribute('data-average-rating') === '0.00';

      const hiddenByStyle = (widget.style && widget.style.display === 'none');
      const noneTextEl = block.querySelector('.jdgm-prev-badge__text');
      const saysNone = noneTextEl && /Keine Bewertungen/i.test(noneTextEl.textContent || '');

      if (zeroReviews || hiddenByStyle || saysNone) {
        // kompletten Produktblock entfernen, damit KEIN Weißraum bleibt
        block.remove();
      }
    });
  }

  // initial beim Laden
  document.addEventListener('DOMContentLoaded', pruneEmptyJudgeBlocks);

  // bei Variant-Wechsel erneut prüfen
  document.addEventListener('variant:change', pruneEmptyJudgeBlocks);})(); 

(function () {
  function ensureOverlay() {
    if (document.querySelector('.checkout-loader-overlay')) return;
    const overlay = document.createElement('div');
    overlay.className = 'checkout-loader-overlay';
    overlay.innerHTML = '<div class="checkout-loader-spinner" aria-label="Loading"></div>';
    document.body.appendChild(overlay);
  }

  function showOverlay() {
    ensureOverlay();
    document.querySelector('.checkout-loader-overlay').classList.add('is-visible');
  }

  function hideOverlay() {
    const ov = document.querySelector('.checkout-loader-overlay');
    if (ov) ov.classList.remove('is-visible');
  }

  function isCheckoutTarget(el) {
    if (!el) return false;

    const href = (el.getAttribute?.('href') || '').toLowerCase();
    const name = (el.getAttribute?.('name') || '').toLowerCase();
    const id = (el.getAttribute?.('id') || '').toLowerCase();
    const cls = (el.getAttribute?.('class') || '').toLowerCase();
    const text = (el.innerText || el.value || '').toLowerCase();

    if (href.includes('/checkout')) return true;
    if (name === 'checkout') return true;
    if (text.includes('checkout') || text.includes('zur kasse') || text.includes('kasse')) return true;
    if (cls.includes('checkout') || id.includes('checkout')) return true;

    return false;
  }

  document.addEventListener('click', function (e) {
    const el = e.target.closest('a, button, input[type="submit"], input[type="button"]');
    if (!el) return;

    if (isCheckoutTarget(el)) {
      showOverlay();
      setTimeout(hideOverlay, 8000);
    }
  }, true);
})();

(function () {
  // Create overlay once
  function ensureOverlay() {
    if (document.querySelector('.checkout-loader-overlay')) return;
    const overlay = document.createElement('div');
    overlay.className = 'checkout-loader-overlay';
    overlay.innerHTML = '<div class="checkout-loader-spinner" aria-label="Loading"></div>';
    document.body.appendChild(overlay);
  }

  function showOverlay() {
    ensureOverlay();
    document.querySelector('.checkout-loader-overlay').classList.add('is-visible');
  }

  // 1) ловим submit любой формы, которая ведет в /checkout
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = (form.getAttribute('action') || '').toLowerCase();

    // Shopify cart -> checkout обычно action="/cart" и submit кнопка name="checkout"
    // А иногда сразу action="/checkout"
    const hasCheckoutBtn = !!form.querySelector('[name="checkout"]');

    if (action.includes('/checkout') || hasCheckoutBtn) {
      showOverlay();
      // Не блокируем submit, иначе можем сломать логику.
      // Наша цель — просто показать анимацию ДО ухода.
    }
  }, true);

  // 2) фоллбек: если checkout — это ссылка /checkout (в некоторых drawer)
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href*="/checkout"]');
    if (!a) return;

    // тут можно НЕ preventDefault, просто покажем оверлей
    showOverlay();
  }, true);
})();

// Erzwinge das Weiterschalten ohne Rücksicht auf Verluste FARBEN VARIANTEN BEI EXTRA KOLLEKTIONEN
const forceNext = () => {
  const gallery = document.querySelector('media-carousel');
  const slides = gallery?.querySelectorAll('.product-gallery__media');
  const current = Array.from(slides).findIndex(s => s.classList.contains('is-selected'));
  
  if (gallery && current < slides.length - 1) {
    gallery.select(current + 1);
  }
};

(() => {
const RULES = [
  { path: "/collections/lampen-kupfer", optionValue: "Kupfer" },
  { path: "/collections/lampen-bronze", optionValue: "Bronze" },
  { path: "/collections/lampen-gold", optionValue: "Gold" },
  { path: "/collections/wandlampen-aussen-anthrazit", optionValue: "Anthrazit" },
];

const rule = RULES.find(r => location.pathname.startsWith(r.path));
if (!rule) return;

const TARGET_PATH = rule.path;
const TARGET_OPTION_VALUE = rule.optionValue;



  if (!location.pathname.startsWith(TARGET_PATH)) return;

  const productCache = new Map();
  const processedHandles = new Set();

  function normalizeSrc(url) {
    if (!url) return null;
    if (url.startsWith("//")) return "https:" + url;
    return url;
  }

  function setImgToUrl(img, newUrl) {
    if (!img || !newUrl) return;
    const url = normalizeSrc(newUrl);
    img.src = url;
    img.removeAttribute("srcset"); // wichtig, sonst gewinnt oft srcset
  }

  function extractHandleFromCard(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const href = a.getAttribute("href") || "";
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getProductJson(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    const p = fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);

    productCache.set(handle, p);
    return p;
  }

  function findCopperVariant(product) {
    if (!product?.variants?.length) return null;
    return (
      product.variants.find(
        (variant) =>
          Array.isArray(variant.options) &&
          variant.options.includes(TARGET_OPTION_VALUE)
      ) || null
    );
  }

  function getVariantImageUrl(variant) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (typeof variant?.featured_image === "string") return variant.featured_image;
    return null;
  }

  function updateCard(card, variant, imgUrl) {
    const imgs = card.querySelectorAll(
      "img.product-card__image, img.product-card__image--primary, img.product-card__image--secondary"
    );
    imgs.forEach((img) => setImgToUrl(img, imgUrl));

    const link = card.querySelector('a[href*="/products/"]');
    if (link && variant?.id) {
      const href = link.getAttribute("href") || "";
      const base = href.split("?")[0];
      link.setAttribute("href", `${base}?variant=${variant.id}`);
    }
  }

  async function processCard(card) {
    const handle = extractHandleFromCard(card);
    if (!handle) return;

    // Wichtig: nach AJAX-Pagination kommen neue Card-Elemente,
    // aber die Handles sind oft die gleichen -> wenn du willst,
    // dass auch gleiche Handles auf neuer Seite neu gesetzt werden,
    // dann processedHandles NICHT blocken oder beim Seitenwechsel clearen.
    if (processedHandles.has(handle)) return;

    processedHandles.add(handle);

    const product = await getProductJson(handle);
    if (!product) return;

    const copperVariant = findCopperVariant(product);
    if (!copperVariant) return;

    const imgUrl = getVariantImageUrl(copperVariant);
    if (!imgUrl) return;

    updateCard(card, copperVariant, imgUrl);
  }

  // --- Lazy via IntersectionObserver ---
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const card = entry.target;
        io.unobserve(card);
        processCard(card);
      }
    },
    {
      root: null,
      rootMargin: "200px 0px",
      threshold: 0.01,
    }
  );

  function observeAllCards() {
    document.querySelectorAll(".product-card").forEach((card) => io.observe(card));
  }

  function reinitCopperGrid({ clearProcessed = false } = {}) {
    if (clearProcessed) processedHandles.clear();
    observeAllCards();
  }

  // MutationObserver: falls Pagination/Filter per AJAX Inhalte austauscht
  function attachMutationObserver() {
    const grid =
      document.querySelector("#CollectionProductGrid") ||
      document.querySelector(".collection") ||
      document.querySelector(".product-grid") ||
      document.querySelector("main");

    if (!grid || attachMutationObserver._attached) return;
    attachMutationObserver._attached = true;

    const mo = new MutationObserver(() => {
      clearTimeout(window.__copperSwapT);
      window.__copperSwapT = setTimeout(() => reinitCopperGrid(), 120);
    });
    mo.observe(grid, { childList: true, subtree: true });
  }

  // Facet-link Pagination (Impact AJAX)
  function attachFacetHandlers() {
    if (attachFacetHandlers._attached) return;
    attachFacetHandlers._attached = true;

    document.addEventListener(
      "click",
      (e) => {
        const a = e.target.closest('a[is="facet-link"]');
        if (!a) return;
        if (!location.pathname.startsWith(TARGET_PATH)) return;

        // Bei Pagination kommen neue Cards -> wir wollen neu laufen.
        // Wenn gleiche Handles auf mehreren Seiten vorkommen können:
        // clearProcessed = true
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 250);
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 900);
      },
      true
    );

    // Back/Forward + History-Updates von Facets
    const _pushState = history.pushState;
    history.pushState = function (...args) {
      _pushState.apply(this, args);
      if (location.pathname.startsWith(TARGET_PATH)) {
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 250);
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 900);
      }
    };

    const _replaceState = history.replaceState;
    history.replaceState = function (...args) {
      _replaceState.apply(this, args);
      if (location.pathname.startsWith(TARGET_PATH)) {
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 250);
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 900);
      }
    };

    window.addEventListener("popstate", () => {
      if (location.pathname.startsWith(TARGET_PATH)) {
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 250);
        setTimeout(() => reinitCopperGrid({ clearProcessed: true }), 900);
      }
    });
  }

  function boot() {
    reinitCopperGrid();
    attachMutationObserver();
    attachFacetHandlers();
  }

  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("load", boot);
  window.addEventListener("pageshow", boot);
  document.addEventListener("shopify:section:load", boot);
})();

/*LOGO NUR BEI WEVER*/
(function () {
  function getVendor() {
    // je nach Theme/Shopify-Setup
    return (
      window?.meta?.product?.vendor ||
      window?.ShopifyAnalytics?.meta?.product?.vendor ||
      window?.__st?.vendor ||
      null
    );
  }

  function addBrandBadgeToGallery() {
    const vendor = (getVendor() || "").trim();

    if (vendor !== "WEVER & DUCRÉ") return;

    document.body.classList.add("vendor-wever");

    const gallery = document.querySelector(".product-gallery__ar-wrapper");
    if (!gallery) return;
    if (gallery.querySelector(".brand-badge-overlay")) return;

    const badge = document.createElement("a");
    const localizedRootLink = document.querySelector('a.header__logo, .header__logo a');
    badge.href = new URL('collections/wever-ducre-designerleuchten', localizedRootLink?.href || (window.location.origin + '/')).href;
    badge.className = "brand-badge-overlay";
    badge.setAttribute("aria-label", "Zu allen Wever & Ducré Designerleuchten");
    badge.innerHTML = `
      <img
        src="https://cdn.shopify.com/s/files/1/0864/9470/8047/files/Wever_Ducre_Logo.jpg?v=1772012906"
        alt=""
        loading="lazy"
        width="3320"
        height="1956"
      >
    `;
    gallery.appendChild(badge);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addBrandBadgeToGallery);
  } else {
    addBrandBadgeToGallery();
  }

  window.addEventListener("load", addBrandBadgeToGallery);
  setTimeout(addBrandBadgeToGallery, 600);
  setTimeout(addBrandBadgeToGallery, 1500);
})();

/*KACHELN BILDER*/
document.addEventListener('DOMContentLoaded', () => {
  const tilesWrap = document.getElementById('product-image-tiles');
  const gallery = document.querySelector('.product-gallery__media-list');
  const data = window.currentProductTiles;

  if (!tilesWrap || !gallery || !data) return;

  function norm(value) {
    return value == null ? '' : String(value).trim();
  }

  function getVariant(id) {
    return data.variants.find(v => String(v.id) === String(id));
  }

  function buildTiles(variant) {
    const tiles = [];

    const ip = norm(variant?.schutzart_ip).toUpperCase();
    if (['IP44', 'IP65', 'IP67'].includes(ip)) {
      tiles.push(`
        <div class="product-image-tile" title="Schutzart">
          <span class="product-image-tile__icon">💧</span>
          <div class="product-image-tile__value">${ip}</div>
        </div>
      `);
    }

const dimmbar = norm(variant?.dimmbar).toLowerCase();
if (dimmbar) {
  const yes = ['ja','yes','true','1','dimmbar'].includes(dimmbar);

  if (yes) {
    tiles.push(`
      <div class="product-image-tile" title="Dimmbar">
        <span class="product-image-tile__icon">◔</span>
        <div class="product-image-tile__value">Dimmbar</div>
      </div>
    `);
  }
}

    const sockel = norm(variant?.sockel).toUpperCase();
if (sockel) {
  tiles.push(`
    <div class="product-image-tile product-image-tile--text-only" title="Fassung">
      <div class="product-image-tile__value">${sockel}</div>
    </div>
  `);
}

    const lm = norm(variant?.leuchtmittel).toLowerCase();
if (lm) {
  const incl = ['inklusive','inkl','enthalten','included','ja','yes','true','1'].some(v => lm.includes(v));
  const excl = ['exklusive','exkl','nicht enthalten','excluded','nein','no','false','0'].some(v => lm.includes(v));

  if (incl || excl) {
    tiles.push(`
      <div class="product-image-tile product-image-tile--bulb" title="${incl ? 'Leuchtmittel enthalten' : 'Leuchtmittel nicht enthalten'}">
        <span class="product-image-tile__icon ${incl ? '' : 'product-image-tile__icon--excluded'}">☀</span>
        <div class="product-image-tile__value">${incl ? 'Inkl.' : 'Exkl.'}</div>
      </div>
    `);
  }
}

    tilesWrap.innerHTML = tiles.join('');
  }

  function updateVisibility() {
    const first = gallery.querySelector('.product-gallery__media:first-child');
    if (first && first.classList.contains('is-selected') && tilesWrap.innerHTML.trim() !== '') {
      tilesWrap.classList.remove('is-hidden');
    } else {
      tilesWrap.classList.add('is-hidden');
    }
  }

  function updateTiles(variantId) {
    const variant = getVariant(variantId || data.selectedVariantId);
    if (!variant) return;
    buildTiles(variant);
    updateVisibility();
  }

  updateTiles(data.selectedVariantId);

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    data.selectedVariantId = variant.id;
    updateTiles(variant.id);
  });

  const observer = new MutationObserver(() => updateVisibility());
  observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
});

// SUCHFELD IMMER OFFEN //
document.addEventListener('DOMContentLoaded', () => {
  const searchWrap = document.querySelector('.header__desktop-search-wrap');
  if (!searchWrap) return;

  const input = searchWrap.querySelector('.header__desktop-search-input');
  const box = searchWrap.querySelector('.header__search-predictive');
  const inner = searchWrap.querySelector('.header__search-predictive-inner');
  const tabs = searchWrap.querySelectorAll('.header__search-tab');
  const searchForm = searchWrap.querySelector('.header__desktop-search-form');
  if (!searchForm) return;

  const searchLabels = searchForm.dataset;

  // Use the server-rendered search action as the source of truth for market + locale.
  // This avoids stale browser-specific Shopify.routes.root values (observed in Firefox).
  const searchActionUrl = new URL(searchForm.getAttribute('action') || '/search', window.location.origin);
  const searchResultsPath = searchActionUrl.pathname.replace(/\/+$/, '') || '/search';
  const searchRoot = searchResultsPath.endsWith('/search')
    ? searchResultsPath.slice(0, -'/search'.length)
    : '';
  const predictiveSearchPath = `${searchRoot}/search/suggest.json`;

  const escapeSearchLabel = value => String(value).replace(/[&<>"']/g, char => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[char]));

  let productsController;
  let collectionsController;
  let debounceTimer;

  let activeTab = 'products';
  let currentQuery = '';
  let cachedProducts = [];
  let cachedCollections = [];

  const moneyFormat = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });

  function closeBox() {
    box.hidden = true;
    inner.innerHTML = '';
  }

  function openBox() {
    box.hidden = false;
  }

  function setActiveTab(tabName) {
    activeTab = tabName;

    tabs.forEach(tab => {
      if (tab.dataset.searchTab === tabName) {
        tab.classList.add('is-active');
      } else {
        tab.classList.remove('is-active');
      }
    });
  }

async function fetchProducts(query) {
  if (productsController) productsController.abort();
  productsController = new AbortController();

  const url =
    predictiveSearchPath +
    `?q=${encodeURIComponent(query)}` +
    `&resources[type]=product` +
    `&resources[limit]=6` +
    `&resources[options][unavailable_products]=last` +
    `&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor`;

  const response = await fetch(url, {
    signal: productsController.signal,
    headers: { Accept: 'application/json' }
  });

  if (!response.ok) throw new Error('Product search failed');

  return response.json();
}

  async function fetchCollections(query) {
    if (collectionsController) collectionsController.abort();
    collectionsController = new AbortController();

    const url = `${predictiveSearchPath}?q=${encodeURIComponent(query)}&resources[type]=collection&resources[limit]=6`;

    const response = await fetch(url, {
      signal: collectionsController.signal,
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) throw new Error('Collection search failed');

    return response.json();
  }

  function renderProducts(query, products) {
    if (!products.length) {
      inner.innerHTML = `
        <div class="header__search-empty">${escapeSearchLabel(searchLabels.emptyProducts || 'Keine passenden Produkte gefunden.')}</div>
      `;
      openBox();
      return;
    }

    const html = products.map(product => {
      const image = product.featured_image?.url
        ? `<img class="header__search-item-image" src="${product.featured_image.url}&width=120" alt="${product.title.replace(/"/g, '&quot;')}">`
        : `<div class="header__search-item-image"></div>`;

      let priceHtml = '';
      if (product.price) {
        let price = String(product.price).replace(',', '.');
        price = Number(price);

        if (!isNaN(price)) {
          // Predictive Search returns decimal currency amounts, not cents.

          const formattedPrice = moneyFormat.format(price);
          priceHtml = `<div class="header__search-item-price">${escapeSearchLabel(searchLabels.priceFrom || 'ab')} ${formattedPrice}</div>`;
        }
      }

      return `
        <a href="${product.url}" class="header__search-item">
          ${image}
          <div class="header__search-item-title">${product.title}</div>
          ${priceHtml}
        </a>
      `;
    }).join('');

    inner.innerHTML = `
      ${html}
      <a class="header__search-view-all" href="${searchResultsPath}?q=${encodeURIComponent(query)}">${escapeSearchLabel(searchLabels.viewAll || 'Alle Ergebnisse ansehen')}</a>
    `;

    openBox();
  }

function renderCollections(query, collections) {
  if (!collections.length) {
    inner.innerHTML = `
      <div class="header__search-empty">${escapeSearchLabel(searchLabels.emptyCollections || 'Keine passenden Marken oder Kategorien gefunden.')}</div>
    `;
    openBox();
    return;
  }

  const html = collections.map(collection => {
    return `
      <a href="${collection.url}" class="header__search-item">
        <div class="header__search-item-title">${collection.title}</div>
      </a>
    `;
  }).join('');

  inner.innerHTML = html;
  openBox();
}

  input.addEventListener('input', () => {
    const query = input.value.trim();
    currentQuery = query;

    clearTimeout(debounceTimer);

    if (query.length < 2) {
      cachedProducts = [];
      cachedCollections = [];
      closeBox();
      return;
    }

    debounceTimer = setTimeout(async () => {
      try {
        cachedCollections = [];
        setActiveTab('products');

        const data = await fetchProducts(query);
        cachedProducts = data?.resources?.results?.products || [];

        renderProducts(query, cachedProducts);
      } catch (error) {
        if (error.name !== 'AbortError') {
          closeBox();
        }
      }
    }, 250);
  });

  tabs.forEach(tab => {
    tab.addEventListener('click', async () => {
      const tabName = tab.dataset.searchTab;
      setActiveTab(tabName);

      if (currentQuery.length < 2) return;

      if (tabName === 'products') {
        renderProducts(currentQuery, cachedProducts);
        return;
      }

      if (!cachedCollections.length) {
        try {
          const data = await fetchCollections(currentQuery);
          cachedCollections = data?.resources?.results?.collections || [];
        } catch (error) {
          if (error.name !== 'AbortError') {
            cachedCollections = [];
          }
        }
      }

      renderCollections(currentQuery, cachedCollections);
    });
  });

  document.addEventListener('click', (event) => {
    if (!searchWrap.contains(event.target)) {
      closeBox();
    }
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2) {
      if (activeTab === 'products' && cachedProducts.length) {
        renderProducts(currentQuery, cachedProducts);
      } else if (activeTab === 'collections' && cachedCollections.length) {
        renderCollections(currentQuery, cachedCollections);
      }
    }
  });
});

